module.exports = __webpack_public_path__ + "media/images/flags/CH-b98e14aedaf9737b412eead8ae4457af.svg";